import React from "react";
import Marquee from "react-fast-marquee";
import { ArrowUp } from "./Icon";

const MarqueeSection = () => {
	return (
		<section className="marquee-section">
			{/* <Marquee>
				<h6 className="title">
					Trending Tokens
					<ArrowUp />
				</h6>
				<div className="d-flex gap-4">
					{data.map((item, index) => (
						<div className="marquee-item" key={index}>
							<img src="/img/artist-icon.png" alt="" />
							<span className="badge">#{index + 1}</span>
							<span className="name">{item.name}</span>
						</div>
					))}
				</div>
			</Marquee> */}
		</section>
	);
};
const data = [
	{
		name: "$MOCK1",
	},
	{
		name: "$MOCK2",
	},
	{
		name: "$MOCK3",
	},
	{
		name: "$MOCK4",
	},
	{
		name: "$MOCK5",
	},
	{
		name: "$MOCK6",
	},
	{
		name: "$MOCK7",
	},
	{
		name: "$MOCK8",
	},
	{
		name: "$MOCK9",
	},

];
export default MarqueeSection;
